import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import useClientMediaQuery from 'utils/useClientMediaQuery';

import DesktopView from './desktop-view';
import MobileView from './mobile-view';

const Timeline = () => {
    const theme = useTheme();
    const matchDownSm = useClientMediaQuery(theme.breakpoints.down('md'), { defaultMatches: false });

    return (
        <Box>
            {matchDownSm && <MobileView />}
            {!matchDownSm && <DesktopView />}
        </Box>
    );
};

export default Timeline;
